import { useState } from "react";
import { storage, db } from "../config/firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { doc, updateDoc } from "firebase/firestore";
import { compressImage } from "../utils/compressImage";

export default function ProductImageUpload({ sku, currentImageUrl, onUploaded }) {
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState(currentImageUrl || null);


  async function handleFileChange(e) {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    setPreview(URL.createObjectURL(file));

    try {
      const compressed = await compressImage(file);

      // Storage path keyed by SKU — re-uploading replaces the old photo
      const storageRef = ref(storage, `product-images/${sku}.jpg`);
      await uploadBytes(storageRef, compressed);
      const url = await getDownloadURL(storageRef);

      await updateDoc(doc(db, "products", sku), { imageUrl: url });
      onUploaded && onUploaded(url);
    } catch (err) {
      alert("Upload failed: " + err.message);
    } finally {
      setUploading(false);
    }
  }

  return (
    <div className="product-image-upload">
      {preview && <img src={preview} alt={sku} width={120} />}
      <input type="file" accept="image/*" onChange={handleFileChange} disabled={uploading} />
      {uploading && <p>Uploading...</p>}
    </div>
  );
}
